/**
 * /led-scroller — бегущая строка на весь экран телефона, планшета или ТВ.
 *
 * Экран сам становится табло: текст идёт через него крупно, без видео и файлов.
 * Один рисовальщик (Board) рисует и предпросмотр на странице, и полноэкранный
 * показ — это один и тот же <canvas>, который общий примитив __wholeScreen
 * разворачивает на весь экран (на iPhone — наложением поверх страницы).
 *
 * Арифметика ленты — общий модуль public/js/ticker-motion.js (тот же у слоя
 * /video-watermark и титра /video-editor): копии, скорость в знаках в секунду,
 * «справа налево». Ход копится в «кеглях» (offEm) с НАСТОЯЩИМ шагом между
 * кадрами: смена размера или поворот экрана не дёргает строку назад, а слабый
 * экран (3 кадра в секунду) не замедляет её — только делает дёрганей.
 *
 * Табло читают вдоль длинной стороны. Если экран стоит вертикально, а
 * ориентацию браузер закрепить не дал (iPhone, планшеты), строка рисуется
 * повёрнутой на 90° — телефон кладут боком, и буквы стоят как надо.
 *
 * Скорость 0 — надпись стоит; несколько строк при этом сменяют друг друга
 * (CYCLE_MS), каждая во всю ширину: так делают таблички «ИМЯ» / «Добро
 * пожаловать», которые держат в аэропорту.
 *
 * Мигание — не чаще двух раз в секунду (WCAG 2.3.1: не больше трёх вспышек).
 * Разбор — docs/why/ticker.md.
 */
(function () {
'use strict';

var CFG = window.__LS_CFG || {};
var T = CFG.t || {};
var SLUG = 'led-scroller';
var FONT = '"Arial Black","Segoe UI",Arial,"Noto Sans",sans-serif';
var DOT_FONT = '"Arial","Segoe UI","Noto Sans",sans-serif';
var DOT_ROWS = 16;              // строк светодиодов в высоте буквы
var CYCLE_MS = 3000;            // неподвижные фразы сменяют друг друга
var COLORS = { red: '#ff3030', green: '#39ff5a', amber: '#ffb000', white: '#ffffff', blue: '#3aa0ff', rainbow: 'rainbow' };
var DEF = {
    text: '', speed: 3, size: 75, style: 'dots', color: 'red', fg: COLORS.red, bg: '#000000',
    dir: CFG.locale === 'ar' ? 'right' : 'left', blink: 'off', mirror: false
};
var S = {};

function $(id) { return document.getElementById(id); }
function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
function TS() { return window.__toolSettings || null; }
function TM() { return window.TickerMotion || null; }
function feat(f, data) { try { if (window.__aeFeature) window.__aeFeature(f, data || {}); } catch (e) {} }
function diag(issue, data) { try { if (window.__aeDiagnostic) window.__aeDiagnostic(Object.assign({ issue: issue }, data || {})); } catch (e) {} }
function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) {} }
function hex(v, fb) { return /^#[0-9a-f]{6}$/i.test(String(v || '')) ? String(v).toLowerCase() : fb; }
function items() { var tm = TM(); return tm ? tm.items(S.text) : String(S.text || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean); }
function sep() { var tm = TM(); return tm ? tm.SEP : ' • '; }
function isRtl(s) { var tm = TM(); return tm ? tm.isRtl(s) : false; }
function textOf() { return items().join(sep()); }

/* ── состояние: ссылка → память страницы → умолчание ─────────────────────── */
function sanitize(o) {
    var s = Object.assign({}, DEF, o || {});
    s.text = String(s.text == null ? '' : s.text).slice(0, 500);
    s.speed = clamp(Math.round(Number(s.speed)), 0, 12); if (!isFinite(s.speed)) s.speed = DEF.speed;
    s.size = clamp(Math.round(Number(s.size)), 30, 95); if (!isFinite(s.size)) s.size = DEF.size;
    s.style = s.style === 'solid' ? 'solid' : 'dots';
    s.color = COLORS[s.color] ? s.color : 'custom';
    s.fg = s.color === 'custom' ? hex(s.fg, DEF.fg) : (s.color === 'rainbow' ? DEF.fg : COLORS[s.color]);
    s.bg = hex(s.bg, DEF.bg);
    s.dir = s.dir === 'right' ? 'right' : 'left';
    s.blink = (s.blink === 'slow' || s.blink === 'fast') ? s.blink : 'off';
    s.mirror = s.mirror === true || s.mirror === 1 || s.mirror === '1';
    return s;
}
function fromUrl() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return null; }
    if (!q.has('t')) return null;
    var o = { text: q.get('t') };
    if (q.has('c')) { var c = q.get('c'); if (COLORS[c]) o.color = c; else { o.color = 'custom'; o.fg = '#' + c.replace(/^#/, ''); } }
    if (q.has('bg')) o.bg = '#' + q.get('bg').replace(/^#/, '');
    if (q.has('sp')) o.speed = q.get('sp');
    if (q.has('sz')) o.size = q.get('sz');
    if (q.has('st')) o.style = q.get('st');
    if (q.has('d')) o.dir = q.get('d');
    if (q.has('b')) o.blink = q.get('b');
    if (q.has('m')) o.mirror = q.get('m') === '1';
    return o;
}
function shareUrl() {
    var p = new URLSearchParams();
    p.set('t', S.text);
    p.set('c', S.color === 'custom' ? S.fg.slice(1) : S.color);
    if (S.bg !== DEF.bg) p.set('bg', S.bg.slice(1));
    p.set('sp', String(S.speed));
    p.set('sz', String(S.size));
    p.set('st', S.style);
    p.set('d', S.dir);
    if (S.blink !== 'off') p.set('b', S.blink);
    if (S.mirror) p.set('m', '1');
    return location.origin + location.pathname + '?' + p.toString();
}
var saveT = 0;
function persist() {
    clearTimeout(saveT);
    saveT = setTimeout(function () { var ts = TS(); if (ts) ts.save(SLUG, 'state', S); }, 300);
}

/* ── табло ────────────────────────────────────────────────────────────────── */
function Board(cv) {
    this.cv = cv;
    this.g = cv.getContext('2d');
    this.offEm = 0;
    this.last = 0;
    this.paused = false;
    this.mask = null;
    this.maskKey = '';
    this.sprites = {};
    this.frames = 0;
    this.failed = false;
}
Board.prototype.restart = function () { this.offEm = 0; this.last = 0; };
Board.prototype.frame = function (now) {
    var cv = this.cv, g = this.g;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cw = cv.clientWidth, ch = cv.clientHeight;
    if (!cw || !ch) return;
    var W = Math.round(cw * dpr), H = Math.round(ch * dpr);
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    // Шаг — настоящее время между кадрами: при 3 кадрах в секунду (слабый ТВ,
    // нагруженный телефон) строка идёт с той же скоростью, только дёрганей.
    // Зажим 0,1 с замедлял её ровно во столько раз (замер 04.11: 0,74 вместо
    // 3,3 кегля в секунду). Разрыв дольше 3 с — вкладка спала: продолжаем
    // с того же места, без рывка (кадр раз в секунду бывает и у живой вкладки).
    var dt = this.last ? (now - this.last) / 1000 : 0;
    if (!(dt > 0) || dt > 3) dt = 0;
    this.last = now;
    var tm = TM();
    if (!this.paused && tm) this.offEm += tm.speed(S.speed, 1) * dt;   // в кеглях: скорость при кегле 1
    this.frames++;
    var rot = H > W * 1.15;
    var Lw = rot ? H : W, Lh = rot ? W : H;
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.globalAlpha = 1;
    g.fillStyle = S.bg;
    g.fillRect(0, 0, W, H);
    if (rot) { g.translate(W, 0); g.rotate(Math.PI / 2); }
    if (S.mirror) { g.translate(Lw, 0); g.scale(-1, 1); }
    var show = S.blink === 'off' || Math.floor(now / (S.blink === 'fast' ? 250 : 500)) % 2 === 0;
    var list = items();
    if (!list.length) { this.hint(g, Lw, Lh); return; }
    var stat = S.speed <= 0;
    // Неподвижно и фраз несколько — по очереди, каждая во всю ширину.
    var txt = stat && list.length > 1 ? list[Math.floor(now / CYCLE_MS) % list.length] : list.join(sep());
    if (S.style === 'dots') this.dots(g, txt, stat, Lw, Lh, now, show);
    else this.solid(g, txt, stat, Lw, Lh, now, show);
};
Board.prototype.hint = function (g, Lw, Lh) {
    var fs = Math.max(12, Lh * 0.18);
    g.font = '600 ' + fs + 'px ' + DOT_FONT;
    g.textAlign = 'center';
    g.textBaseline = 'middle';
    g.fillStyle = 'rgba(255,255,255,.45)';
    g.fillText(T.empty || '…', Lw / 2, Lh / 2);
    g.textAlign = 'left';
};
function rainbowAt(x, now) { return 'hsl(' + Math.round((x * 0.35 + now * 0.08) % 360) + ',100%,58%)'; }
Board.prototype.solid = function (g, txt, stat, Lw, Lh, now, show) {
    var tm = TM();
    var fs = Math.max(8, Lh * S.size / 100);
    g.font = '900 ' + fs + 'px ' + FONT;
    g.textBaseline = 'middle';
    g.textAlign = 'left';
    try { g.direction = isRtl(txt) ? 'rtl' : 'ltr'; } catch (e) {}
    var y = Lh / 2;
    var paint = function (s, x) {
        if (S.color === 'rainbow') {
            var gr = g.createLinearGradient(0, 0, Lw, 0);
            for (var i = 0; i <= 6; i++) gr.addColorStop(i / 6, rainbowAt(i / 6 * Lw, now));
            g.fillStyle = gr;
        } else g.fillStyle = S.fg;
        g.fillText(s, x, y);
    };
    if (stat) {
        // Стоит на месте: по центру и целиком — длинная надпись уменьшается.
        var tw = g.measureText(txt).width;
        var k = Math.min(1, (Lw * 0.94) / Math.max(1, tw));
        if (k < 1) { fs *= k; g.font = '900 ' + fs + 'px ' + FONT; tw = g.measureText(txt).width; }
        if (show) paint(txt, (Lw - tw) / 2);
        return;
    }
    var unit = txt + sep();
    var span = Math.max(1, g.measureText(unit).width);
    if (!show || !tm) return;
    tm.each(this.offEm * fs, Lw, span, span, S.dir === 'right', function (x) { paint(unit, x); });
};
/* Маска строки в «светодиодах»: текст рисуется кеглем DOT_ROWS px в
   невидимый холст, каждая точка маски — один светодиод табло. */
Board.prototype.buildMask = function (unit, rows) {
    var key = unit + '|' + rows;
    if (this.mask && this.maskKey === key) return this.mask;
    var c = document.createElement('canvas'), g = c.getContext('2d');
    var font = '700 ' + DOT_ROWS + 'px ' + DOT_FONT;
    g.font = font;
    var w = Math.max(1, Math.ceil(g.measureText(unit).width));
    w = Math.min(w, 32000);
    c.width = w; c.height = rows;
    g.font = font;
    g.textBaseline = 'middle';
    g.textAlign = 'left';
    try { g.direction = isRtl(unit) ? 'rtl' : 'ltr'; } catch (e) {}
    g.fillStyle = '#fff';
    g.fillText(unit, 0, rows / 2 + 0.5);
    var d = g.getImageData(0, 0, w, rows).data;
    var bits = new Uint8Array(w * rows);
    for (var i = 0; i < w * rows; i++) bits[i] = d[i * 4 + 3] > 110 ? 1 : 0;
    this.mask = { w: w, h: rows, bits: bits };
    this.maskKey = key;
    return this.mask;
};
Board.prototype.sprite = function (size, color, lit) {
    var key = size + '|' + color + '|' + (lit ? 1 : 0);
    if (this.sprites[key]) return this.sprites[key];
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var g = c.getContext('2d'), r = size / 2;
    if (lit) {
        var gr = g.createRadialGradient(r, r, 0, r, r, r);
        gr.addColorStop(0, color);
        gr.addColorStop(0.62, color);
        gr.addColorStop(1, 'rgba(0,0,0,0)');
        g.fillStyle = gr;
        g.beginPath(); g.arc(r, r, r, 0, Math.PI * 2); g.fill();
    } else {
        g.globalAlpha = 0.13;
        g.fillStyle = color;
        g.beginPath(); g.arc(r, r, r * 0.62, 0, Math.PI * 2); g.fill();
    }
    this.sprites[key] = c;
    var keys = Object.keys(this.sprites);
    if (keys.length > 24) delete this.sprites[keys[0]];
    return c;
};
Board.prototype.dots = function (g, txt, stat, Lw, Lh, now, show) {
    var tm = TM();
    var cell = Math.max(3, (Lh * S.size / 100) / DOT_ROWS);
    var unit = stat ? txt : txt + sep();
    // Неподвижная надпись должна поместиться целиком: светодиоды мельчают.
    if (stat) {
        this.g.font = '700 ' + DOT_ROWS + 'px ' + DOT_FONT;
        var tcols = Math.ceil(this.g.measureText(txt).width) + 2;
        cell = Math.max(2, Math.min(cell, Lw / tcols));
    }
    var rows = Math.max(DOT_ROWS + 2, Math.floor(Lh / cell));
    var cols = Math.max(1, Math.floor(Lw / cell));
    var x0 = (Lw - cols * cell) / 2, y0 = (Lh - rows * cell) / 2;
    var m = this.buildMask(unit, rows);
    // Какая колонка маски горит в каждой колонке табло: те же копии ленты, что
    // у «букв», в единицах светодиода — движение шагом в один светодиод.
    var map = new Int32Array(cols).fill(-1);
    if (stat) {
        var start = Math.floor((cols - m.w) / 2);
        for (var sc = 0; sc < cols; sc++) { var su = sc - start; if (su >= 0 && su < m.w) map[sc] = su; }
    } else if (tm) {
        var offC = Math.floor(this.offEm * DOT_ROWS);
        tm.each(offC, cols, m.w, m.w, S.dir === 'right', function (cx) {
            var from = Math.max(0, Math.round(cx)), to = Math.min(cols, Math.round(cx) + m.w);
            for (var c = from; c < to; c++) map[c] = c - Math.round(cx);
        });
    }
    var size = Math.max(2, Math.round(cell));
    var rainbow = S.color === 'rainbow';
    var on = rainbow ? null : this.sprite(size, S.fg, true);
    var off = this.sprite(size, rainbow ? '#ffffff' : S.fg, false);
    for (var c2 = 0; c2 < cols; c2++) {
        var u = map[c2];
        var x = x0 + c2 * cell;
        for (var r = 0; r < rows; r++) {
            var lit = show && u >= 0 && m.bits[r * m.w + u];
            var yy = y0 + r * cell;
            if (lit && rainbow) {
                g.fillStyle = rainbowAt(x, now);
                g.beginPath(); g.arc(x + cell / 2, yy + cell / 2, cell * 0.42, 0, Math.PI * 2); g.fill();
            } else g.drawImage(lit ? on : off, x, yy, cell, cell);
        }
    }
};

/* ── QR-код: открыть ту же строку на другом телефоне ────────────────────────
   Своя копия qrcode-generator (/vendor/qrcode) — по нажатию, через общий
   загрузчик __vendorScript: обе половины сайта отдают её сами, без CDN. */
function drawQr(canvas, url) {
    var qrcode = window.qrcode;
    var q = qrcode(0, 'L');
    q.addData(url, 'Byte');
    q.make();
    var n = q.getModuleCount(), quiet = 4, px = Math.max(2, Math.floor(600 / (n + quiet * 2)));
    var size = (n + quiet * 2) * px;
    canvas.width = canvas.height = size;
    var g = canvas.getContext('2d');
    g.fillStyle = '#fff'; g.fillRect(0, 0, size, size);
    g.fillStyle = '#000';
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) if (q.isDark(r, c)) g.fillRect((c + quiet) * px, (r + quiet) * px, px, px);
    return n;
}

/* ── страница ─────────────────────────────────────────────────────────────── */
function init() {
    var stage = $('lsStage'), cv = $('lsBoard');
    if (!stage || !cv || cv.__lsBoard) return;
    var board = new Board(cv);
    cv.__lsBoard = board;
    var linked = fromUrl();
    var ts = TS();
    S = sanitize(linked || (ts ? ts.load(SLUG, 'state', null) : null));
    var recent = (ts && ts.load(SLUG, 'recent', [])) || [];
    if (!Array.isArray(recent)) recent = [];
    var typed = false;

    var txt = $('lsText'), speed = $('lsSpeed'), size = $('lsSize');
    var fg = $('lsFg'), bg = $('lsBg'), mirror = $('lsMirror');

    function seg(name, val) {
        var box = document.querySelector('[data-ls-seg="' + name + '"]');
        if (!box) return;
        box.querySelectorAll('button[data-v]').forEach(function (b) {
            var on = b.getAttribute('data-v') === val;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.classList.toggle('on', on);
        });
    }
    function speedWord(v) {
        if (v <= 0) return T.speed_static || '0';
        return v + ' · ' + (v <= 2 ? T.speed_slow : v <= 5 ? T.speed_normal : v <= 8 ? T.speed_fast : T.speed_vfast);
    }
    function sync() {
        if (document.activeElement !== txt) txt.value = S.text;
        speed.value = S.speed; size.value = S.size;
        $('lsSizeV').textContent = S.size + '%';
        $('lsSpeedV').textContent = speedWord(S.speed);
        fg.value = S.fg; bg.value = S.bg;
        $('lsFgSw').style.background = S.color === 'rainbow' ? 'conic-gradient(#ff3030,#ffb000,#39ff5a,#3aa0ff,#b04dff,#ff3030)' : S.fg;
        $('lsBgSw').style.background = S.bg;
        mirror.checked = !!S.mirror;
        seg('style', S.style); seg('dir', S.dir); seg('blink', S.blink);
        document.querySelectorAll('#lsColors [data-color]').forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-color') === S.color ? 'true' : 'false');
        });
        cv.setAttribute('aria-label', (T.board_label || '') + (textOf() ? ': ' + String(S.text).replace(/\s+/g, ' ').trim() : ''));
        var has = !!textOf();
        stage.classList.toggle('ls-has', has);
        $('lsGo').disabled = !has;
        $('lsShare').disabled = !has;
        $('lsQr').disabled = !has;
    }
    /* Правка видна сразу: один кадр рисуется тут же, не дожидаясь, пока
       наблюдатель видимости заметит табло (в медленном браузере он отвечает
       через секунду и больше — стенд 04.11 читал табло прежнего вида). */
    function redraw() { try { board.frame(performance.now()); } catch (e) { reportFrame(e); } kick(); }
    function change() { sync(); persist(); redraw(); }
    function setText(v, how) {
        S.text = String(v || '').slice(0, 500);
        board.restart();
        change();
        if (!typed && S.text.trim()) { typed = true; try { if (window.__stage) window.__stage('typed', { how: how }); } catch (e) {} }
    }

    txt.addEventListener('input', function () { setText(txt.value, 'typed'); });
    speed.addEventListener('input', function () { S.speed = clamp(+speed.value || 0, 0, 12); change(); });
    size.addEventListener('input', function () { S.size = clamp(+size.value || 75, 30, 95); change(); });
    fg.addEventListener('input', function () { S.fg = hex(fg.value, S.fg); S.color = 'custom'; change(); });
    bg.addEventListener('input', function () { S.bg = hex(bg.value, S.bg); change(); });
    mirror.addEventListener('change', function () { S.mirror = mirror.checked; change(); });
    document.querySelectorAll('[data-ls-seg]').forEach(function (box) {
        box.addEventListener('click', function (e) {
            var b = e.target.closest('button[data-v]'); if (!b) return;
            var name = box.getAttribute('data-ls-seg'), v = b.getAttribute('data-v');
            if (name === 'style') S.style = v; else if (name === 'dir') { S.dir = v; board.restart(); } else if (name === 'blink') S.blink = v;
            change();
        });
    });
    $('lsColors').addEventListener('click', function (e) {
        var b = e.target.closest('[data-color]'); if (!b) return;
        var c = b.getAttribute('data-color');
        S.color = c;
        if (c !== 'rainbow') S.fg = COLORS[c];
        change();
    });
    var ideas = $('lsIdeas');
    if (ideas) ideas.addEventListener('click', function (e) {
        var b = e.target.closest('[data-idea]'); if (!b) return;
        setText(b.getAttribute('data-text') || b.textContent, 'idea');
        feat('idea', { i: +b.getAttribute('data-idea') });
        try { txt.focus({ preventScroll: true }); txt.select(); } catch (err) {}
    });

    /* Недавние строки — одна строка = одна кнопка; хранятся у посетителя. */
    function renderRecent() {
        var box = $('lsRecent');
        box.querySelectorAll('.ls-chip').forEach(function (n) { n.remove(); });
        recent.forEach(function (r) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ls-chip';
            b.textContent = r.length > 40 ? r.slice(0, 38) + '…' : r;
            b.title = r;
            b.addEventListener('click', function () { setText(r, 'recent'); feat('recent'); });
            box.appendChild(b);
        });
        box.hidden = !recent.length;
    }
    function remember() {
        var t = String(S.text || '').trim();
        if (!t) return;
        recent = [t].concat(recent.filter(function (x) { return x !== t; })).slice(0, 6);
        var s2 = TS(); if (s2) s2.save(SLUG, 'recent', recent);
        renderRecent();
    }

    /* ── показ на весь экран ── */
    var screenDoor = null, shownAt = 0, barT = 0, show = null, exitVia = '', pushed = false;
    function showBar() {
        stage.classList.add('ls-bar-on');
        clearTimeout(barT);
        barT = setTimeout(function () { stage.classList.remove('ls-bar-on'); }, 3000);
    }
    function setPauseBtn() {
        var b = $('lsPause');
        b.setAttribute('aria-pressed', board.paused ? 'true' : 'false');
        b.textContent = board.paused ? '▶' : '❚❚';
        b.setAttribute('aria-label', board.paused ? (T.stage_play || '') : (T.stage_pause || ''));
    }
    function closed() {
        if (!shownAt) return;
        var secs = (performance.now() - shownAt) / 1000;
        shownAt = 0;
        stage.classList.remove('ls-live', 'ls-bar-on');
        try { if (window.__wakeLock) window.__wakeLock.releaseHold(SLUG); } catch (e) {}
        try { if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); } catch (e) {}
        if (pushed && exitVia !== 'back') { pushed = false; try { history.back(); } catch (e) {} }
        pushed = false;
        board.paused = false; setPauseBtn();
        if (show && secs >= 3) {
            var fps = Math.round((board.frames - show.frames0) / Math.max(0.001, secs));
            try {
                if (window.__aeToolComplete) window.__aeToolComplete({
                    secs: Math.round(secs), fps: fps, exit: exitVia || 'browser', mode: show.mode, from: show.from,
                    style: S.style, speed: S.speed, size: S.size, color: S.color, blink: S.blink, mirror: S.mirror ? 1 : 0,
                    lines: items().length, chars: textOf().length, rotated: cv.height > cv.width * 1.15 ? 1 : 0,
                    paused: show.pauses, speed_changes: show.speedChanges
                });
            } catch (e) {}
            if (fps < 20 && secs >= 5) diag('ls_low_fps', { fps: fps, w: cv.width, h: cv.height, style: S.style, mode: show.mode });
        }
        show = null; exitVia = '';
        try { $('lsGo').focus({ preventScroll: true }); } catch (e) {}
    }
    function open(from) {
        if (!textOf() || shownAt) return;
        if (typeof window.__wholeScreen !== 'function') { diag('ls_no_whole_screen'); return; }
        if (!screenDoor) screenDoor = window.__wholeScreen(stage, {
            key: SLUG,
            onChange: function (on, mode) {
                if (on) {
                    if (show) show.mode = mode || show.mode;
                    // iPhone: наложение, а не полный экран — жест «назад» должен
                    // закрыть табло, а не увести со страницы.
                    if (mode === 'overlay' && !pushed) { try { history.pushState({ lsStage: 1 }, ''); pushed = true; } catch (e) {} }
                } else closed();
            }
        });
        shownAt = performance.now();
        show = { from: from || 'button', mode: '', frames0: board.frames, pauses: 0, speedChanges: 0 };
        board.restart();
        board.paused = false; setPauseBtn();
        stage.classList.add('ls-live');
        kick();   // табло могло стоять вне экрана — цикл не ждёт наблюдателя видимости
        remember();
        try { if (window.__stage) window.__stage('show', { from: show.from }); } catch (e) {}
        // Экран не должен гаснуть, пока строка на нём.
        try { if (window.__wakeLock) window.__wakeLock.hold(SLUG); } catch (e) {}
        var started = show;
        screenDoor.enter().then(function () {
            // Табло — вдоль длинной стороны: где браузер даёт, закрепляем альбомную.
            var lock = 'na';
            var done = function (r) {
                lock = r;
                feat('show', { from: started.from, mode: started.mode || 'fullscreen', style: S.style, color: S.color, speed: S.speed,
                    size: S.size, blink: S.blink, mirror: S.mirror ? 1 : 0, dir: S.dir, lines: items().length, chars: textOf().length,
                    cycle: S.speed <= 0 && items().length > 1 ? 1 : 0, lock: lock });
            };
            try {
                if (screen.orientation && screen.orientation.lock && window.matchMedia('(pointer: coarse)').matches) {
                    screen.orientation.lock('landscape').then(function () { done('locked'); }, function () { done('refused'); });
                } else done('na');
            } catch (e) { done('refused'); }
        });
        // Держит ли браузер экран — спрашиваем примитив, когда он уже ответил.
        setTimeout(function () {
            if (!shownAt || show !== started) return;
            try {
                var st = window.__wakeLock ? window.__wakeLock.state() : null;
                feat('wake', { mode: st && st.mode ? st.mode : 'none', held: st && st.held ? 1 : 0 });
            } catch (e) {}
        }, 1500);
        showBar();
    }
    function exit(via) { exitVia = via; if (screenDoor) screenDoor.exit(); }
    window.addEventListener('popstate', function () { if (shownAt && pushed) { pushed = false; exit('back'); } });
    $('lsGo').addEventListener('click', function () { open('button'); });
    $('lsStart').addEventListener('click', function (e) { e.stopPropagation(); open(stage.classList.contains('ls-linked') ? 'link' : 'board_button'); });
    $('lsClose').addEventListener('click', function () { exit('close'); });
    $('lsPause').addEventListener('click', function () { board.paused = !board.paused; if (show && board.paused) show.pauses++; setPauseBtn(); showBar(); });
    function nudgeSpeed(d) { S.speed = clamp(S.speed + d, 0, 12); if (show) show.speedChanges++; change(); showBar(); }
    $('lsSlower').addEventListener('click', function () { nudgeSpeed(-1); });
    $('lsFaster').addEventListener('click', function () { nudgeSpeed(1); });
    cv.addEventListener('click', function () {
        if (shownAt) { if (stage.classList.contains('ls-bar-on')) stage.classList.remove('ls-bar-on'); else showBar(); }
        else if (textOf()) open('board');
    });
    document.addEventListener('keydown', function (e) {
        if (!shownAt) return;
        if (window.__keyOwnedByFocus && window.__keyOwnedByFocus(e)) return;
        if (e.code === 'Space') { e.preventDefault(); $('lsPause').click(); }
        else if (e.code === 'ArrowUp' || e.code === 'ArrowRight') { e.preventDefault(); nudgeSpeed(1); }
        else if (e.code === 'ArrowDown' || e.code === 'ArrowLeft') { e.preventDefault(); nudgeSpeed(-1); }
    });

    /* ── ссылка на эту строку ── */
    $('lsShare').addEventListener('click', function () {
        if (!textOf()) return;
        var url = shareUrl();
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
            navigator.share({ url: url, title: T.share_title || document.title })
                .then(function () { feat('share', { via: 'share' }); }, function () { feat('share', { via: 'share_cancel' }); });
            return;
        }
        var done = function () { toast(T.share_copied || '', 'success'); feat('share', { via: 'copy' }); };
        var fail = function () { toast(String(T.share_failed || '').replace(':url', url), 'warning'); feat('share', { via: 'fail' }); };
        try { navigator.clipboard.writeText(url).then(done, fail); } catch (e) { fail(); }
    });

    /* ── QR ── */
    var dlg = $('lsQrDlg'), qrBtn = $('lsQr'), qrLoad = null;
    // Библиотеку начинаем грузить, как только к кнопке потянулись (наведение,
    // фокус, касание): под нагрузкой она едет секунды, и нажатие без отклика
    // выглядит как сломанная кнопка.
    function loadQr() {
        if (window.qrcode) return Promise.resolve();
        if (qrLoad) return qrLoad;
        qrLoad = (typeof window.__vendorScript === 'function'
            ? window.__vendorScript('/vendor/qrcode/qrcode.min.js', { expect: 'qrcode', label: 'qrcode' })
            : Promise.reject(new Error('no __vendorScript')))
            .then(function () {}, function (e) { qrLoad = null; throw e; });
        return qrLoad;
    }
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { qrBtn.addEventListener(ev, function () { loadQr().catch(function () {}); }, { passive: true }); });
    qrBtn.addEventListener('click', function () {
        if (!textOf()) return;
        var url = shareUrl();
        var go = function () {
            var n;
            try { n = drawQr($('lsQrCanvas'), url); }
            catch (e) {
                // Слишком много данных для кода (длинный текст в адресе).
                toast(T.qr_too_long || '', 'warning');
                diag('ls_qr_too_long', { len: url.length });
                return;
            }
            try { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } catch (e) { dlg.setAttribute('open', ''); }
            feat('qr', { modules: n, len: url.length });
        };
        if (window.qrcode) { go(); return; }
        qrBtn.setAttribute('aria-busy', 'true');
        qrBtn.disabled = true;
        loadQr().then(go, function () { toast(T.qr_failed || '', 'warning'); diag('ls_qr_lib'); })
            .then(function () { qrBtn.removeAttribute('aria-busy'); qrBtn.disabled = !textOf(); });
    });
    $('lsQrClose').addEventListener('click', function () { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } });

    /* Предпросмотр живёт, только пока его видно: табло, ушедшее за край
       страницы, кадров не рисует. */
    var visible = true, raf = 0, reported = false;
    function reportFrame(e) {
        if (reported) return;
        reported = true;
        try { if (window.__handleError) window.__handleError(e, 'ls_frame'); } catch (_) {}
    }
    function loop(now) {
        raf = 0;
        if (!visible && !shownAt) return;
        try { board.frame(now); } catch (e) { reportFrame(e); }
        raf = requestAnimationFrame(loop);
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }
    if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) kick(); }).observe(stage);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

    renderRecent();
    sync();
    kick();
    if (linked) {
        stage.classList.add('ls-linked');
        feat('opened_link');
    }
    window.__lsDebug = { get state() { return Object.assign({}, S); }, board: board, shareUrl: shareUrl, get live() { return !!shownAt; } };
}

/* ticker-motion.js грузится тегом перед этим файлом; если он пришёл позже
   (запасной адрес), табло поднимается, как только модуль есть. */
function boot() {
    if (window.TickerMotion) { init(); return; }
    var tries = 0, h = setInterval(function () {
        if (window.TickerMotion || ++tries > 100) { clearInterval(h); init(); }
    }, 100);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
